// Native
import { Pipe, PipeTransform } from '@angular/core';

// Imported
import * as numeral from 'numeral';
numeral.register('locale', 'ru', {
  delimiters: {
    thousands: ' ',
    decimal: ','
  },
  abbreviations: {
    thousand: 'тыс.',
    million: 'млн.',
    billion: 'млрд.',
    trillion: 'трлн.'
  },
  currency: {
    symbol: '₽'
  }
});

numeral.locale('ru');

@Pipe({
  name: 'numeral'
})
export class NumeralPipe implements PipeTransform {
  static formats: any = {
    currency: '0,0[.]00',
    currency$: '0,0[.]00 $',
    number: '0,0[.]00',
    aroundDecimal: '0,0.0',
    percentages: '0.00%',
    thousand: '0.0 a',
    short: '0 a',
    int: '0'
  };

  transform(value: any, key: string = 'currency$', fraction: number = 2): any {
    let format: string;

    if (key === 'toFixed')
      return parseFloat(value).toFixed(fraction).toString();

    format = NumeralPipe.formats[key];
    if (key === 'shortExtended')
      if (value < 10000)
        return value;
      else
        format = '0 a';

    return numeral(value).format(format);
  }

}
